import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useI18n } from '../i18n'

export function LogoutPage() {
  const { t } = useI18n()
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => navigate('/login'), 3000)
    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <div className="flex min-h-full items-center justify-center px-4">
      <div className="text-center">
        <p className="text-xl text-text-muted">{t('auth.logoutMessage')}</p>
      </div>
    </div>
  )
}
